const INVITE_TTL_MS = 7 * 24 * 60 * 60 * 1000;

export const getPendingInvitePath = () => {
  try {
    const parsed = JSON.parse(sessionStorage.getItem('pendingInvite') || 'null');
    if (
      typeof parsed?.token === 'string'
      && parsed.token
      && Date.now() - Number(parsed.createdAt) <= INVITE_TTL_MS
    ) {
      return `/accept-invite/${encodeURIComponent(parsed.token)}`;
    }
  } catch (error) {
    // Clear malformed state below.
  }
  sessionStorage.removeItem('pendingInvite');
  return '/dashboard';
};
